import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';
import { HourCard } from 'types/data/hourCard.t';

// Define a type for the slice state
interface HourCardsState {
  value: HourCard[];
}

// Define the initial state using that type
const initialState: HourCardsState = {
  value: []
};

export const hourCardsSlice = createSlice({
  name: 'hourCards',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    addHourCard: (state, action: PayloadAction<HourCard>) => {
      state.value = [...state.value, action.payload];
    },
    removeHourCard: (state, action: PayloadAction<number>) => {
      state.value = state.value.filter(p => p.id !== action.payload);
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    updateHourCard: (state, action: PayloadAction<HourCard>) => {
      state.value = state.value.map(p => (p.id === action.payload.id ? action.payload : p));
    }
  }
});

export const { addHourCard, removeHourCard, updateHourCard } = hourCardsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectHourCards = (state: RootState) => state.hourCards.value;

export default hourCardsSlice.reducer;
